import React, { useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  FormControl,
  FormLabel,
  Heading,
  Input,
  NumberInput,
  NumberInputField,
  Select,
  SimpleGrid,
  Textarea,
} from "@chakra-ui/react";

const initialForm = {
  customerName: "",
  customerEmail: "",
  amount: 0,
  currency: "USD",
  description: "",
};

const CreateInvoicePanel = ({ onSubmit, isSubmitting }) => {
  const [form, setForm] = useState(initialForm);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    const success = await onSubmit({
      ...form,
      amount: Number(form.amount || 0),
    });
    if (success) {
      setForm(initialForm);
    }
  };

  return (
    <Card variant="outline" _hover={{ boxShadow: "md" }} transition="box-shadow 0.2s ease">
      <CardHeader>
        <Heading size="sm">Create Invoice</Heading>
      </CardHeader>
      <CardBody>
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
          <FormControl>
            <FormLabel>Customer Name</FormLabel>
            <Input value={form.customerName} onChange={(e) => handleChange("customerName", e.target.value)} />
          </FormControl>
          <FormControl>
            <FormLabel>Customer Email</FormLabel>
            <Input type="email" value={form.customerEmail} onChange={(e) => handleChange("customerEmail", e.target.value)} />
          </FormControl>
          <FormControl>
            <FormLabel>Amount</FormLabel>
            <NumberInput
              min={0}
              precision={2}
              value={form.amount}
              onChange={(_, valueNumber) => handleChange("amount", Number.isFinite(valueNumber) ? valueNumber : 0)}
            >
              <NumberInputField />
            </NumberInput>
          </FormControl>
          <FormControl>
            <FormLabel>Currency</FormLabel>
            <Select value={form.currency} onChange={(e) => handleChange("currency", e.target.value)}>
              <option value="USD">USD</option>
              <option value="EUR">EUR</option>
              <option value="GBP">GBP</option>
              <option value="INR">INR</option>
            </Select>
          </FormControl>
          <FormControl gridColumn={{ md: "1 / -1" }}>
            <FormLabel>Description</FormLabel>
            <Textarea value={form.description} onChange={(e) => handleChange("description", e.target.value)} />
          </FormControl>
        </SimpleGrid>
        <Button mt={4} colorScheme="blue" onClick={handleSubmit} isLoading={isSubmitting}>
          Create Invoice
        </Button>
      </CardBody>
    </Card>
  );
};

export default CreateInvoicePanel;
